import { fetch } from '@/shared/fetch';

export const fetchConsultationTranscriptExists = (
    consultationUid: string,
): Promise<boolean> => {
    return fetch(
        `/api/caregiverspace/consultations/${consultationUid}/transcript/exists`,
        'GET',
    );
};
